<script setup>
import { ref } from 'vue';

const props = defineProps({
    singleCard: {
        type: Boolean,
        default: false
    },
    disableCollapsible: {
        type: Boolean,
        default: false
    }
});

const cards = ref([
    { id: Date.now(), collapsed: false }
]);

let cardIdCounter = Date.now();

const addNewCard = () => {
    if (props.singleCard) return;
    cardIdCounter++;
    cards.value.push({
        id: cardIdCounter,
        collapsed: false
    });
};

</script>

<template>
    <div class="flex flex-col h-full">
        <div class="flex flex-col gap-4 mb-6">
            <div v-for="(card, index) in cards" :key="card.id"
                class="rounded-xl bg-echoes-background-black/80 cursor-pointer ">

            

                <!-- Card Content -->
                <div v-if="!card.collapsed || disableCollapsible" class="p-4 pt-4 flex flex-col gap-4 bg-echoes-background-gray/10">
                    <slot :card="card" :index="index">
                        <div class="w-full p-8 rounded-xl border-2 border-dashed border-echoes-border-gray bg-echoes-background-black/30 flex items-center justify-center">
                            <span class="text-white/50 text-sm">Conteúdo do card vazio</span>
                        </div>
                    </slot>
                </div>
            </div>
        </div>

        <!-- Add Card Button -->
        <div v-if="!singleCard" class="flex justify-center mt-2">
            <button @click="addNewCard" class="flex items-center justify-center bg-echoes-primary hover:bg-echoes-primary/80 transition-colors ease-in-out duration-200 rounded-full h-[35px] w-[35px]">
                <i class="uil uil-plus"></i>
            </button>
        </div>
    </div>
</template>
